import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SiteCookies, SiteStorage } from '@constants/global';
import { environment } from '@environments/environment';
import { IGenericResponse, ILoginPayload, IToken, IUserResponse } from '@interfaces/common';
import { Cookie } from 'ng2-cookies';
import { Observable, map, lastValueFrom } from 'rxjs';
import { UserService } from './user.service';
import { UtilityService } from './utility.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private utility: UtilityService, private router: Router, private user: UserService) { }

  private getData(): Observable<IUserResponse> {
    const accessToken = this.utility.getCookie(SiteCookies.ACCESSTOKEN);
    const refreshToken = this.utility.getCookie(SiteCookies.REFRESHTOKEN);
      const payload: IToken = {
        'token': accessToken,
        'refresh_token': refreshToken
      };
    return this.utility.sendRequest<IUserResponse>(environment.getSiteData, payload).pipe(map(response => response)); // give delay to check the service delay
  }

  async getSiteData(){
    /* const accessToken = this.utility.getCookie(SiteCookies.ACCESSTOKEN);
    const refreshToken = this.utility.getCookie(SiteCookies.REFRESHTOKEN);
      const payload: IToken = {
        'token': accessToken,
        'refresh_token': refreshToken
      };

      return this.utility.sendRequest<IUserResponse>(environment.getSiteData, payload)
      .toPromise()
      .then((data: IUserResponse) => {
        if(data.response.code === '0000'){
          this.user.setUserInfo(data);
          if(!data.response.isLoggedIn){
            this.utility.deleteTokens();
          }
        }
      }).catch((error)=>{
        return this.user.getUserInfo();
      }); */
      /* if(window.location.href.includes('logout')){
        const data$ = this.doLogout();
        return await lastValueFrom(data$).then((data: IGenericResponse) => {
          this.redirectToLogin(document.referrer);
        }).catch((error)=>{
          console.log(error);
          this.redirectToLogin(document.referrer);
          return null;
        });
      }else{ */
        const data$ = this.getData();
        return await lastValueFrom(data$).then((data: IUserResponse) => {
          if(data && data.response.code === '0000'){
            this.user.setUserInfo(data);
            if(!data.response.isLoggedIn){
              this.utility.deleteTokens();
            }
          }
        }).catch((error)=>{
          console.log(error);
          window.location.href = environment.maintainence;
          return this.user.getUserInfo();
        });
      //}
  }

  login(payload: ILoginPayload){
    return this.utility.sendRequest<IUserResponse>(environment.login, payload);
  }

  logout(){
    //do logout if api fails or success
    const payload = {
      token: this.utility.getCookie(SiteCookies.REFRESHTOKEN)
    };
    const subs = { 
      next: (response: IGenericResponse) => {
        this.redirectToLogin();
      },
      error: (e: any) =>{
        console.log(e);
        this.redirectToLogin();
      }};
    this.utility.sendRequest<IGenericResponse>(environment.logout, payload).subscribe(subs);
  }

  setUserDetails(data: IUserResponse){
    this.user.setUserInfo(data);
  }

  redirectToLogin(){
    this.utility.deleteTokens();
    this.user.deleteUserInfo();
    this.utility.deleteFromBrowserStorage(SiteStorage.ISAGEMODALVIEWED);
    this.utility.deleteFromBrowserStorage(SiteStorage.ISSUBSTITUTIONMODALDECLINED);
    Cookie.delete(SiteCookies.ORDERPLACED, '/', environment.cookieDomain);
    if(this.user.getUserInfo().siteInfo?.location_url){
      window.location.href = this.user.getUserInfo().siteInfo?.location_url!;
    }else{
      this.router.navigate(['/']);
    }
  }

  /* private doLogout(): Observable<IGenericResponse> {
    const refreshToken = this.utility.getCookie(SiteCookies.REFRESHTOKEN);
      const payload = {
        'token': refreshToken
      };
    return this.utility.sendRequest<IGenericResponse>(environment.logout, payload).pipe(map(response => response)); // give delay to check the service delay
  } */
}
